// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"9bceda5a","555":"37e643af","798":"ef2d9e3e","868":"c7aba221","902":"f1e12e3e","904":"ded08a8e","923":"b9657ff5","977":"e7ad86f2"}[chunkId] + ".chunk.js";
};